import { createContext } from 'react';
import { ICategory } from '../../types';

export interface ICategoriesContext {
  categories: {
    [pimId: string]: ICategory;
  };
  rootCategory: number;
}

export const initialValue = {
  categories: {},
  rootCategory: -1,
};

export const DfCategoriesContext = createContext<ICategoriesContext>(initialValue);
